'use client'

import * as React from "react"
import Link from "next/link"
import { HelpCircle, ArrowRight } from "lucide-react"
import { Button } from "@sarkiai/ui"
import { useTranslations } from "@/components/I18nProvider"
import PricingSection from "@/components/home/Pricing"
import FaqList from "@/components/home/FaqList"

export default function PricingPage() {
  const t = useTranslations("pricing")
  const tPricing = useTranslations("pricing_page")

  return (
    <main className="flex min-h-screen flex-col">
      {/* Hero Section */}
      <section className="relative py-24 md:py-32 bg-black text-white overflow-hidden px-4 lg:px-12">
        <div className="absolute inset-0 bg-white/5 opacity-50" />
        <div className="container relative z-10 mx-auto">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h1 className="text-4xl md:text-5xl  tracking-tighter uppercase leading-none">
              {t('title')}
            </h1>
            <p className="text-xl md:text-2xl opacity-70 max-w-2xl mx-auto leading-relaxed">
              {t('subtitle')}
            </p>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" />
      </section>

      {/* Pricing Section - uses shared component */}
      <PricingSection showHeader={false} className="py-20 md:py-32" />

      {/* FAQ Section */}
      <section className="py-24 md:py-32 bg-black/5 dark:bg-white/5 px-4 lg:px-12">
        <div className="container mx-auto space-y-16">
          <div className="text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-6 py-2 rounded-2xl bg-black dark:bg-white text-white dark:text-black shadow-xl shadow-black/10">
              <HelpCircle className="h-5 w-5" />
              <span className=" uppercase tracking-widest text-xs">FAQ</span>
            </div>
            <h2 className="text-4xl md:text-5xl  uppercase tracking-tight">{tPricing("faq_section_title")}</h2>
          </div>

          <FaqList category="pricing" showTitle={false} />
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 bg-background border-t border-black/5 dark:border-white/5 px-4 lg:px-12">
        <div className="container mx-auto text-center space-y-10 group">
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl  uppercase tracking-tighter text-black dark:text-white leading-none">
              {tPricing("cta_title")}
            </h2>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              {tPricing("cta_subtitle")}
            </p>
          </div>
          <div className="pt-4">
            <Button size="default" asChild className="h-12 px-8 rounded-2xl bg-black dark:bg-white text-white dark:text-black font-bold uppercase tracking-widest text-sm shadow-xl hover:bg-black dark:hover:bg-white">
              <Link href="/contact">
                {tPricing("cta_button")}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </main>
  )
}
